import { RootState } from '@/core/redux';

export const getIsLoggedIn = (state: RootState): boolean => !!state.auth.authInfo;
